import React, { useState } from "react";
import "../../../ProjectsV2/ProjectFinance/Estimate/ApprovalModal/ApprovalModal.css";

const approvers = [
  { id: 1, title: "Директор", name: "Бекбауов С." },
  { id: 2, title: "Финансовый руководитель", name: "Тлебаева Б." },
  { id: 3, title: "Руководитель отдела", name: "Казиев Б." },
];

const defaultChecked = [3]; // По умолчанию выбран руководитель отдела

const SalaryApprovalModal = ({ open, onClose, onSubmit, departmentName, period }) => {
  const [checked, setChecked] = useState(defaultChecked);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!open) return null;

  const handleToggle = (id) => {
    setChecked((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checked.length === 0) return;

    setIsSubmitting(true);
    try {
      if (onSubmit) {
        await onSubmit(checked);
      }
    } catch (error) {
      console.error("Ошибка при отправке на согласование:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="approval-modal-backdrop" onClick={onClose} />
      <div className="approval-modal">
        <div className="approval-modal-title">Согласование зарплаты</div>
        
        {/* Информация об отделе и периоде */}
        {(departmentName || period) && (
          <div style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            marginBottom: "18px",
            fontSize: "16px",
            color: "#666"
          }}>
            {departmentName && (
              <span>{departmentName}</span>
            )}
            {period && (
              <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span>📅</span>
                {period}
              </span>
            )}
          </div>
        )}

        <div className="approval-modal-warning">
          <span className="approval-modal-warning-icon">⚠️</span>
          <span>
            Вы отправляете на согласование расчёт зарплат за выбранный период для
            всего отдела.
          </span>
        </div>
        <div className="approval-modal-label">
          Выберите кому отправить на согласование:
        </div>
        <form onSubmit={handleSubmit}>
          <div className="approval-modal-list">
            {approvers.map((a) => (
              <label
                key={a.id}
                className={`approval-checkbox-label${
                  checked.includes(a.id) ? " checked" : ""
                }`}
              >
                <input
                  type="checkbox"
                  checked={checked.includes(a.id)}
                  onChange={() => handleToggle(a.id)}
                  disabled={isSubmitting}
                />
                <span className="approval-checkbox-title">{a.title}</span>
                <span className="approval-checkbox-name">{a.name}</span>
              </label>
            ))}
          </div>
          <div className="approval-modal-actions">
            <button
              type="button"
              className="approval-btn outline"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Отмена
            </button>
            <button
              type="submit"
              className="approval-btn green"
              disabled={isSubmitting || checked.length === 0}
            >
              {isSubmitting ? "Отправка..." : "Отправить"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default SalaryApprovalModal;

